import type { CompanyDto } from "~/types/company";

export class CompanyRepository {
	private baseUrl = globalConfig.API + "/companies";

	private companyUrl(companySlugOrId: number | string) {
		const { isBlue, isNotBlueHU } = useRuntimeConfig().public.activeConfig;
		const urlQueryParams = [];

		if (isBlue) {
			urlQueryParams.push("scope[]=isBlue");
		} else if (isNotBlueHU) {
			urlQueryParams.push("scope[]=isNotBlue");
		}

		const query = urlQueryParams.length > 0 ? `?${urlQueryParams.join("&")}` : "";
		return `${this.baseUrl}/${companySlugOrId}${query}`;
	}

	async getCompany(companySlugOrId: number | string): Promise<CompanyDto | null> {
		const { data } = await useFetch(this.companyUrl(companySlugOrId), {
			method: "GET",
		});

		return data.value as CompanyDto | null;
	}

	async fetchCompany(companySlugOrId: number | string): Promise<CompanyDto | null> {
		return await $fetch<CompanyDto>(this.companyUrl(companySlugOrId));
	}
}
